<template>
  <ThePage :title="i18n(translations.title)">
    <template #pageTitle>
      {{ i18n(translations.title) }}
    </template>

    <template #pageActions>
      <div
        class="mb-12 flex flex-col space-y-16 md:mb-0 md:flex-row md:space-x-16 md:space-y-0"
      >
        <RevButton
          full-width="adaptive"
          variant="secondary"
          @click="handleOpenImportExportDrawer"
        >
          {{ i18n(translations.importExport) }}
        </RevButton>

        <RevButton
          full-width="adaptive"
          :to="{ name: ROUTE_NAMES.OPTIONS.PRICING }"
          variant="secondary"
        >
          {{ i18n(translations.managePriceRules) }}
        </RevButton>

        <RevButton
          full-width="adaptive"
          :to="{ name: ROUTE_NAMES.LISTINGS.PRODUCT.SEARCH }"
          variant="primary"
        >
          {{ i18n(translations.create) }}
        </RevButton>
      </div>
    </template>

    <template #pageContent>
      <NavTabs
        :index-route-name="ROUTE_NAMES.LISTINGS.INDEX"
        :label="translations.navigation"
      />

      <ImportExportDrawer />
    </template>
  </ThePage>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { openModal } from '@ds/components/ModalBase'

import { ROUTE_NAMES } from '~/constants/routes'

import translations from './Index.translations'
import { MODAL_NAME as LISTINGS_IMPORT_EXPORT_DRAWER_MODAL_NAME } from './components/ImportExportDrawer/ImportExportDrawer.constants'
import ImportExportDrawer from './components/ImportExportDrawer/ImportExportDrawer.vue'

const i18n = useI18n()

function handleOpenImportExportDrawer() {
  openModal(LISTINGS_IMPORT_EXPORT_DRAWER_MODAL_NAME)
}
</script>
